<template>
    <div>
      <b-card>
        <div title="Profile" active>
            <h4>Preview Employee's CV</h4>
            <div ref='employee'>
              <GenerateProfileEmployee :employee="employee" />
            </div>
        </div>
        <br>
        <div class="d-flex justify-content-end mx-5">
          <b-button
            class="next merge d-flex justify-content-end"
            type="submit"
            variant="primary"
            @click="print">
            Print as PDF
          </b-button>
          </div>
      </b-card>
    </div>
</template>

<script>
import api from '@/api'
import axios from '@/api/handler'
import GenerateProfileEmployee from '@/components/GenerateProfileEmployee.vue'
import Jspdf from 'jspdf'
import moment from 'moment'

export default {
  data() {
    return {
      employeeId: JSON.parse(localStorage.getItem('me')).employeeId,
      id: '',
      employee: {
        fullName: '',
        gender: '',
        role: '',
        birthDate: '',
        knowledge: {},
        phoneNumber: '',
        email: ''
      },
      show: true,
      imageUrl: '',
      base64Image: ''
    }
  },
  components: { GenerateProfileEmployee },
  async created() {
    this.fetchEmployeeProfile()
    this.fetchAvatar()
  },
  methods: {
    async fetchEmployeeProfile() {
      try {
        const { data } = await api.employee.getCVData(this.employeeId)
        this.employee = data.data
      } catch (response) {
        this.errorResponse(response)
      }
    },
    async fetchAvatar() {
      try {
        const { data } = await api.avatar.getAvatar(this.employeeId)
        const buffer = await axios('https://internal-api.staging-gi.web.id' + data.contentUrl, { responseType: 'arraybuffer' })
        this.imageUrl = data.contentUrl
        this.base64Image = Buffer.from(buffer.data, 'binary').toString('base64')
      } catch (response) {
        this.errorResponse(response)
      }
    },
    errorResponse(response) {
      if (response.data) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    stringifiedRole(roles) {
      let role = ''
      roles.map((v, i) => {
        if (i === roles.length - 1) role += v
        else role += `${v}, `
      })
      return role
    },
    async print() {
      const imageData = 'data:image/png;base64, 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'
      const doc = new Jspdf({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      })
      doc.addImage(this.base64Image, 'png', 26, 20, 25, 37.5)
      doc.addImage(imageData, 'png', 150, 25, 40, 0)
      doc.setDrawColor(176, 196, 222)
        .rect(22, 20.1, 170, 39.8)
      doc.setFont('times', 'bold')
        .setDrawColor(176, 196, 222)
        .setLineWidth(5.0)
      doc.line(20, 20, 20, 60)
      var splitFullName = doc.splitTextToSize(this.employee.fullName, 80)
      doc.setFont('times', 'normal')
        .setFontSize(18)
        .text(65, 35, splitFullName)
        .setDrawColor(0, 0, 0)
      doc.setFont('times', 'normal')
        .setFontSize(10)
        .text(`Status: ${this.employee.status}`, 65, 43)
        .setDrawColor(0, 0, 0)
      doc.setFont('times', 'normal')
        .setFontSize(10)
        .text(`Born: ${moment(this.employee.birthDate).format('MMMM DD, YYYY')}`, 65, 47)
        .setDrawColor(0, 0, 0)
      doc.setFont('times', 'normal')
        .setFontSize(10)
        .text(this.employee.role, 65, 51)
        .setDrawColor(0, 0, 0)
      doc.setFont('times', 'bold')
        .setDrawColor(176, 196, 222)
        .setLineWidth(0.2)
        .rect(22, 70.1, 170, 209.9)
      doc.setDrawColor(176, 196, 222)
        .setLineWidth(5.0)
        .line(20, 280.1, 20, 70)
      doc.setFont('times', 'bold')
        .setFontSize(10)
        .text('Education', 27, 78)
        .setDrawColor(176, 196, 222)

      const GAP_LINE = 5
      let yPosition = 85
      const xPosition = 30

      if (this.employee.education && this.employee.education.length) {
        this.employee.education.map((v, i) => {
          doc.setFont('times', 'normal')
            .setFontSize(10)
            .text(xPosition, yPosition, `${i + 1}. ${v.name}, ${v.periode}`)
            .setDrawColor(0, 0, 0)
          yPosition += GAP_LINE
        })
      } else {
        doc.setFont('times', 'normal')
          .setFontSize(10)
          .text('-', xPosition, yPosition)
          .setDrawColor(176, 196, 222)
      }

      doc.setFont('times', 'bold')
        .setFontSize(10)
        .text('Employment History', 27, 100)
        .setDrawColor(176, 196, 222)

      yPosition = 108

      if (this.employee.employmentHistory && this.employee.employmentHistory.length) {
        this.employee.employmentHistory.map((v, i) => {
          doc.setFont('times', 'normal')
            .setFontSize(10)
            .text(xPosition, yPosition, `${i + 1}. ${v.company} (${v.periode}) as ${v.role}`)
            .setDrawColor(0, 0, 0)
          yPosition += GAP_LINE
        })
      } else {
        doc.setFont('times', 'normal')
          .setFontSize(10)
          .text('-', xPosition, yPosition)
          .setDrawColor(176, 196, 222)
      }

      doc.setFont('times', 'bold')
        .setFontSize(10)
        .text('Last Work and Responsibility', 27, 150)
        .setDrawColor(176, 196, 222)

      yPosition = 158

      if (this.employee.lastWorkResponsibilityEmployee && this.employee.lastWorkResponsibilityEmployee.length) {
        this.employee.lastWorkResponsibilityEmployee.map((v, i) => {
          doc.setFont('times', 'normal')
            .setFontSize(10)
            .text(xPosition, yPosition, `${i + 1}. ${this.stringifiedRole(v.roles)} for ${v.projectName} (${v.periode}) at ${v.company}`)
            .setDrawColor(0, 0, 0)
          yPosition += GAP_LINE
        })
      } else {
        doc.setFont('times', 'normal')
          .setFontSize(10)
          .text('-', xPosition, yPosition)
          .setDrawColor(176, 196, 222)
      }
      window.open(doc.output('bloburl'), '_blank')
    }
  }
}
</script>
